import * as React from "react"
import type { SVGProps } from "react"
const SvgSecurity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m10.95 13.41-1.4-1.4a1 1 0 0 0-.7-.3q-.4 0-.7.3t-.3.72q0 .4.3.7l2.1 2.13q.3.3.7.3t.7-.3l4.25-4.25q.3-.3.3-.7 0-.42-.3-.72a1 1 0 0 0-.71-.3q-.42 0-.72.3zm1.05 9.2a2 2 0 0 1-.62-.1A10 10 0 0 1 6 18.35q-2-3.03-2-6.54V7.1q0-.63.36-1.12.37-.5.94-.73l6-2.25a2 2 0 0 1 .7-.12q.35 0 .7.12l6 2.25q.57.23.94.73.36.5.36 1.12v4.72q0 3.51-2 6.54a10 10 0 0 1-5.38 4.17 2 2 0 0 1-.62.1Zm0-2q2.6-.82 4.3-3.3c1.7-2.48 1.7-3.48 1.7-5.5V7.1l-6-2.25L6 7.1v4.72q0 3.03 1.7 5.5c1.7 2.47 2.57 2.75 4.3 3.3Z" />
  </svg>
)
export default SvgSecurity
